export const iareColors = {
    blue: "#35a2eb",
    darkBlue: "#1169a5",
    red: "#ff6384",
    teal: "#4bc0c0",
    orange: "#ff9f40",
    purple: "#9866ff",
    yellow: "#ffcd57",
    green: "#5bbd38",
    grey: "#c9cbcf",
    magenta: "#f763ff",
    black: "#000000",
    white: "#FFFFFF"
}

